import { render, staticRenderFns } from "./view.vue?vue&type=template&id=3bd72c30&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=3bd72c30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd72c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd72c30')) {
      api.createRecord('3bd72c30', component.options)
    } else {
      api.reload('3bd72c30', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=3bd72c30&scoped=true", function () {
      api.rerender('3bd72c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/closeReturn/view.vue"
export default component.exports